export const START_LOGIN_REQUEST = 'START_LOGIN_REQUEST';
export const START_LOGIN_REQUEST_FAILED = 'START_LOGIN_REQUEST_FAILED';
export const START_LOGIN_REQUEST_SUCCESS = 'START_LOGIN_REQUEST_SUCCESS';
export const START_LOGIN_REQUEST_SUCCEEDED = 'START_LOGIN_REQUEST_SUCCEEDED';
export const LOGIN_ERROR = 'LOGIN_ERROR';
export const STORE_LOGIN_RESPONSE = 'STORE_LOGIN_RESPONSE';
export const LOGOUT = 'LOGOUT';
export const SAVED = 'SAVED';
export const IMPORT_DATA_REQUEST = 'IMPORT_DATA_REQUEST';
export const IMPORT_DATA_REQUEST_SENT = 'IMPORT_DATA_REQUEST_SENT';
export const IMPORT_DATA_REQUEST_SUCCEEDED = 'IMPORT_DATA_REQUEST_SUCCEEDED';
export const IMPORT_DATA_ERROR = 'IMPORT_DATA_ERROR';
export const IMPORT_DATA_REQUEST_FAILED = 'IMPORT_DATA_REQUEST_FAILED';
export const PUBLISH_DATA_REQUEST = 'PUBLISH_DATA_REQUEST';
export const PUBLISH_DATA_REQUEST_SENT = 'PUBLISH_DATA_REQUEST_SENT';
export const PUBLISH_DATA_SUCCEED = 'PUBLISH_DATA_SUCCEED';
export const PUBLISH_DATA_REQUEST_SUCCEEDED = 'PUBLISH_DATA_REQUEST_SUCCEEDED';
export const PUBLISH_DATA_ERROR = 'PUBLISH_DATA_ERROR';
export const SET_UPLOADING_DATA_LOADER = 'SET_UPLOADING_DATA_LOADER';
export const SET_PUBLISHING_LOADER = 'SET_PUBLISHING_LOADER';
export const SET_ERRORS = 'SET_ERRORS';
export const SET_IMPORTED_DATA = 'SET_IMPORTED_DATA';
export const SET_ERROR_DATA = 'SET_ERROR_DATA';
export const SET_PUBLISHED_DATA = 'SET_PUBLISHED_DATA';
export const SET_ERROR_PUBLISHED_DATA = 'SET_ERROR_PUBLISHED_DATA';
export const SET_JWT_TOKEN = 'SET_JWT_TOKEN';
export const FETCH_SPORTS_REQUEST = 'FETCH_SPORTS_REQUEST';
export const FETCH_SPORTS_REQUEST_SUCCEEDED = 'FETCH_SPORTS_REQUEST_SUCCEEDED';
export const FETCH_SPORTS_REQUEST_FAILED = 'FETCH_SPORTS_REQUEST_FAILED';
export const STORE_ADMIN_SPORTS = 'STORE_ADMIN_SPORTS';

